<div class="mt-3" *ngIf="loading">
  <span class="spinner-border spinner-border-sm me-2"></span>
  Cargando información...
</div>

<div class="mt-3" *ngIf="!loading && data?.length">

  <div class="table-responsive">
    <table class="table table-bordered table-sm align-middle">
      <thead class="table-light">
        <tr>
          <th>Serie</th>
          <th>Número</th>
          <th>NIT</th>
          <th>Cliente</th>

          <th class="text-end">Cantidad</th>
          <th class="text-end">Precio</th>
          <th class="text-end">Impuestos</th>
          <th class="text-end">Monto</th>

          <th>Código</th>
          <th>Producto</th>

          <th>Destino</th>
          <th>Ubicación</th>

          <th class="text-end">Costo</th>
          <th class="text-end">Margen</th>

          <th>Método de cobro</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let row of data; trackBy: trackById">
          <td>{{ row.series }}</td>
          <td>{{ row.number }}</td>
          <td>{{ row.nit }}</td>
          <td>{{ row.client }}</td>

          <td class="text-end">
            {{ nz(row.quantity) | number:'1.2-2' }}
          </td>
          <td class="text-end">
            {{ nz(row.price) | currency: 'Q' }}
          </td>
          <td class="text-end">
            {{ nz(row.taxes) | currency: 'Q' }}
          </td>
          <td class="text-end">
            {{ nz(row.amount) | currency: 'Q' }}
          </td>

          <td>{{ row.code }}</td>
          <td>{{ row.productName }}</td>

          <td>{{ row.destination }}</td>
          <td>{{ row.place }}</td>

          <td class="text-end">
            {{ nz(row.cost) | currency: 'Q' }}
          </td>
          <td class="text-end">
            {{ nz(row.margin) | number:'1.2-2' }}
          </td>

          <td>{{ row.paymentMethod }}</td>
        </tr>
      </tbody>
    </table>
  </div>

</div>
